module.exports = __webpack_public_path__ + "static/media/mito11.e4984fc0.jpg";